export const ONLINE_LEADERBOARD_PAGE_SIZE = 20;
export const ONLINE_LEADERBOARD_CACHE_MS = 30_000;

export interface NormalizedPage {
  page: number;
  pageSize: number;
  from: number;
  to: number;
}

export function normalizeLeaderboardPage(page: number, pageSize = ONLINE_LEADERBOARD_PAGE_SIZE): NormalizedPage {
  const normalizedPage = Math.max(1, Math.floor(Number(page) || 1));
  const normalizedPageSize = Math.max(5, Math.min(50, Math.floor(Number(pageSize) || ONLINE_LEADERBOARD_PAGE_SIZE)));
  const from = (normalizedPage - 1) * normalizedPageSize;
  return { page: normalizedPage, pageSize: normalizedPageSize, from, to: from + normalizedPageSize - 1 };
}

export function calculateOnlineWinRate(wins: number, draws: number, losses: number): number {
  const matches = Math.max(0, wins) + Math.max(0, draws) + Math.max(0, losses);
  return matches ? Math.round(Math.max(0, wins) / matches * 1_000) / 10 : 0;
}

export function newestTimestamp(values: Array<string | null | undefined>): string | null {
  const timestamps = values
    .filter((value): value is string => Boolean(value) && Number.isFinite(Date.parse(value!)))
    .sort((left, right) => Date.parse(right) - Date.parse(left));
  return timestamps[0] ?? null;
}

export type RankingFreshness = 'live' | 'recent' | 'stale';

export function getRankingFreshness(updatedAt: string | null, now = Date.now()): RankingFreshness {
  if (!updatedAt) return 'stale';
  const age = Math.max(0, now - Date.parse(updatedAt));
  if (!Number.isFinite(age)) return 'stale';
  if (age <= 60_000) return 'live';
  return age <= 5 * 60_000 ? 'recent' : 'stale';
}
